var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeadline28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 1.5C9 1.22386 8.77614 1 8.5 1C8.22386 1 8 1.22386 8 1.5V4H2.5C2.22386 4 2 4.22386 2 4.5V8.5V22.5C2 22.7761 2.22386 23 2.5 23H10.5C10.7761 23 11 22.7761 11 22.5C11 22.2239 10.7761 22 10.5 22H3V9H24V11.5C24 11.7761 24.2239 12 24.5 12C24.7761 12 25 11.7761 25 11.5V8.5V4.5C25 4.22386 24.7761 4 24.5 4H19V1.5C19 1.22386 18.7761 1 18.5 1C18.2239 1 18 1.22386 18 1.5V4H9V1.5ZM24 8V5H18.5H8.5H3V8H24ZM14 18.5C14 16.0147 16.0147 14 18.5 14C20.9853 14 23 16.0147 23 18.5C23 20.9853 20.9853 23 18.5 23C16.0147 23 14 20.9853 14 18.5ZM18.5 13C15.4624 13 13 15.4624 13 18.5C13 21.5376 15.4624 24 18.5 24C21.5376 24 24 21.5376 24 18.5C24 15.4624 21.5376 13 18.5 13ZM19 16.5C19 16.2239 18.7761 16 18.5 16C18.2239 16 18 16.2239 18 16.5V18.5C18 18.7761 18.2239 19 18.5 19H20.5C20.7761 19 21 18.7761 21 18.5C21 18.2239 20.7761 18 20.5 18H19V16.5Z",
  fill: "currentColor"
})));
export default SvgDeadline28;